import { render, staticRenderFns } from "./BuildinLayoutTop.vue?vue&type=template&id=2ecfd088&scoped=true&"
import script from "./BuildinLayoutTop.vue?vue&type=script&lang=ts&"
export * from "./BuildinLayoutTop.vue?vue&type=script&lang=ts&"
import style0 from "./BuildinLayoutTop.vue?vue&type=style&index=0&id=2ecfd088&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfd088",
  null
  
)

export default component.exports